import { useParams } from 'react-router-dom';

const mockData = {
  title: "Dreamscape",
  dimensions: "40 x 60 cm",
  material: "Oil on canvas",
  description: "A surreal landscape inspired by dreams.",
  categories: ["Abstract", "Surreal"],
  src: "/dream.jpeg"
};

function App() {
  const { slug } = useParams();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "2rem",
        alignItems: "start",
        maxWidth: "1200px",
        margin: "40px auto",
        padding: "0 16px"
      }}
    >
      <div
        style={{
          order: 2
        }}
      >
        <h1 style={{ marginBottom: "1em" }}>{mockData.title}</h1>
        <p><b>Dimensions:</b> {mockData.dimensions}</p>
        <p><b>Material:</b> {mockData.material}</p>
        <p>
          {mockData.categories.map((cat, idx) => (
            <a key={cat} href="/" style={{ marginRight: "8px", fontStyle: "italic", color: "black" }}>{cat}</a>
          ))}
        </p>
        {mockData.description && <p>{mockData.description}</p>}
          <p>{slug}</p>
      </div>
      <div
        style={{
          textAlign: "center",
          order: 1
        }}
        className="image-block"
      >
        <img
          src={mockData.src}
          alt={mockData.title}
          style={{
            maxWidth: "100%",
            maxHeight: "500px",
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
          }}
        />
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .image-info { order: 2 !important; }
            .image-block { order: 1 !important; }
            div[style*="grid-template-columns"] {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default App;